<template>
    <tr>
        <th class="text-nowrap" scope="row">
            {{ attribute }}
        </th>
        <td v-for="parentKey in ['attributes', 'old']" class="text-nowrap text-end">
            <div v-if="attribute === 'journey_id'">
                <ActivityLogJourneyChangedDisplay :journeyId="propertiesToShow?.[parentKey]?.[attribute]"/>
            </div>
            <div v-else-if="isDatetimeAttribute(attribute)">
                {{ getDisplayablePropertyValueByKey(attribute, parentKey) }}
            </div>
            <div v-else class="font-monospace text-muted">
                {{ getDisplayablePropertyValueByKey(attribute, parentKey) }}
            </div>
        </td>
    </tr>
</template>
<script setup lang="ts">
import { toRefs } from "vue";
import { DateTime } from "luxon";
import ActivityLogJourneyChangedDisplay from "@components/ActivityLogsModalPlugin/ActivityLogJourneyChangedDisplay.vue";

const props = withDefaults(
    defineProps<{
        propertiesToShow: any;
        attribute: string;
    }>(),
    {}
);

const { propertiesToShow, attribute } = toRefs(props);

const isDatetimeAttribute = (attribute: string) => {
    return (
        attribute.includes("_at") ||
        attribute.includes("_time") ||
        attribute.includes("date") ||
        [
            "arrive_destination_not_before",
            "arrive_destination_no_later_than",
            "depart_origin_not_before",
            "depart_origin_no_later_than",
        ].includes(attribute)
    );
};

const getDisplayablePropertyValueByKey = (attribute: string, parentKey: "old" | "attributes"): string => {
    if (!propertiesToShow.value || !propertiesToShow.value?.[parentKey]?.[attribute]) {
        return "-";
    }

    if (isDatetimeAttribute(attribute)) {
        try {
            return DateTime.fromISO(propertiesToShow.value?.[parentKey]?.[attribute]).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY);
        } catch (e) {
            console.error(e);
        }
    }

    if (attribute === 'password') {
        return '********';
    }

    return propertiesToShow.value?.[parentKey]?.[attribute];
};
</script>
